<template>
    <section class="select-rate-container">
        <div class="actions">
            <div
                v-for="(item, index) in rate"
                :key="index"
                :class="rateClass(item.selected)"
                @click="setSelected(item.value)"
            >
                {{ item.value }}
            </div>
        </div>
        <div class="infos">
            <span>{{ lowScoreMessage }}</span>
            <span> {{ highScoreMessage }}</span>
        </div>
    </section>
</template>

<script>
	const defaultRate = () => [
		{
			value: 1,
			selected: false,
		},
		{
			value: 2,
			selected: false,
		},
		{
			value: 3,
			selected: false,
		},
		{
			value: 4,
			selected: false,
		},
		{
			value: 5,
			selected: false,
		},
		{
			value: 6,
			selected: false,
		},
		{
			value: 7,
			selected: false,
		},
		{
			value: 8,
			selected: false,
		},
		{
			value: 9,
			selected: false,
		},
		{
			value: 10,
			selected: false,
		},
	]

	export default {
		name: 'ui-nps',
		props: {
			value: {
				type: Object,
				default: () => {},
			},

			npsConfig: {
				type: Object,
				default: () => {},
			},
		},

		data() {
			return {
				rate: [...defaultRate()],
			}
		},

		computed: {
			selectedRate() {
				return this.rate.find((element) => element.selected)
			},

			lowScoreMessage() {
				if (!this.npsConfig) return undefined

				return this.npsConfig.nps_score_min_label
			},

			highScoreMessage() {
				if (!this.npsConfig) return undefined

				return this.npsConfig.nps_score_max_label
			},
		},

		watch: {
			selectedRate: {
				handler(value) {
					this.$emit('input', value)
				},

				deep: true,
			},
		},

		mounted() {
			this.$emit('input', this.selectedRate)

		},

		methods: {
			rateClass(selected) {
				return {
					selected: selected,
				}
			},

			setSelected(value) {
				this.rate.forEach((element) => {
					if (element.value == value) {
						element.selected = true
						return
					}

					element.selected = false
				})
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
